import { c as _c } from "react/compiler-runtime";
import { useAnalyticsSkuViewedContext } from '../components/SkuViewed/Context';
import { usePageAction } from './usePageAction';
export const useNonMonetizingPageAction = isMonetizing => {
  const $ = _c(2);
  const {
    skuImpressionId
  } = useAnalyticsSkuViewedContext();
  let t0;
  if ($[0] !== skuImpressionId) {
    t0 = {
      actionSection: "non_monetizing_offer",
      actionType: "select",
      additionalAttributes: {
        sku_impression_id: skuImpressionId
      }
    };
    $[0] = skuImpressionId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const fireNonMonetizingPageAction = usePageAction(t0);
  if (isMonetizing === false) {
    return fireNonMonetizingPageAction;
  }
};